import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Out from '@/pages/Out'
import IndexContent from '@/pages/IndexContent'
import ArticleInit from '@/components/ArticleInit'
import ArticleList from '@/components/ArticleList'
import ArticleDetail from '@/components/ArticleDetail'
import SchoolSummarizeArticle from  '@/components/SchoolSummarizeArticle'
import CampusStyleView from  '@/pages/CampusStyleView'
import SchoolVideo from  '@/pages/SchoolVideo'
import DepartmentContent from  '@/pages/DepartmentContent'
import LibraryContent from  '@/pages/LibraryContent'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      name: 'Index',
      component: Index,
      children: [
        {
          path: '',
          name: 'IndexContent',
          component: IndexContent
        },
        {
          path: '/department',
          name: 'DepartmentContent',
          component: DepartmentContent
        },
        {
          path: '/library',
          name: 'LibraryContent',
          component: LibraryContent
        },
        {
          path: '/ArticleInit',
          name: 'ArticleInit',
          component: ArticleInit,
          children: [
            {
              path: '/ArticleInit/list',
              name: 'ArticleList',
              component: ArticleList,
            },
            {
              path: '/ArticleInit/detail',
              name: 'ArticleDetail',
              component: ArticleDetail,
            },
            {
              path: '/ArticleInit/schoolSummarize',
              name: 'SchoolSummarizeArticle',
              component: SchoolSummarizeArticle,
            },
            {
              // 校园风光
              path: '/ArticleInit/campusStyle',
              name: 'CampusStyleView',
              component: CampusStyleView,
            },
            {
              // 学校视频
              path: '/ArticleInit/schoolVideo',
              name: 'SchoolVideo',
              component: SchoolVideo,
            }
          ]
        }
      ]
    },
    {
      path: '/out/:path',
      name: 'Out',
      component: Out
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js